/* eslint import/prefer-default-export:off */
export const fetchContent = ({ url, edition, lang }) => {
  if (url !== 'editions') {
    const query = lang === 'ar' ?
      `?edition=${edition}&lang=${lang}` :
      `?edition=${edition}`;

    return fetch(`/api/${url}${query}`)
      .then(response => response.json())
      .catch((error) => {
        console.log(`Error fetching page ${url}, with the following message: ${error} `);
        return {};
      });
  }
  const query = lang === 'ar' ? `?lang=${lang}` : '';
  return fetch(`/api/editions${query}`)
    .then(response => response.json())
    .catch((error) => {
      console.log(`Error fetching page ${url}, with the following message: ${error} `);
      return {};
    });
};

export const fetchRelatedContent = ({ url, contentId }) => {
  const s = (`/api/${url}/${contentId}`);
  return fetch(s)
    .then(response => response.json())
    .catch((error) => {
      console.log(`Error fetching page ${url}, with the following message: ${error} `);
      return {};
    });
};

export const fetchPageContent = ({ pageId, lang }) => {
  if (lang === 'ar') {
    return fetch(`/api/universal/${pageId}?lang=${lang}`)
      .then(response => response.json())
      .catch((error) => {
        console.log(`Error fetching page ${pageId}, with the following message: ${error} `);
        return {};
      });
  }
  return fetch(`/api/universal/${pageId}`)
    .then(response => response.json())
    .catch((error) => {
      console.log(`Error fetching page ${pageId}, with the following message: ${error} `);
      return {};
    });
};



// WEBPACK FOOTER //
// ./js/api/index.js